import { ReactNode, useMemo } from 'react'
import Box from 'components/shared/Box'
import { CalendarLegendText } from './styles'
import CalendarLegendBadge, {
    LegendBadgeIconType,
    LegendBadgeType,
} from './components/CalendarLegendBadge'

interface CalendarLegendItemProps {
    badge: LegendBadgeType
    badgeColor?: string
    badgeIcon?: LegendBadgeIconType
    description: ReactNode
    isDescriptionDark?: boolean
    hasDarkMode?: boolean
}

const CalendarLegendItem = ({
    badge,
    badgeColor,
    badgeIcon,
    description,
    isDescriptionDark,
    hasDarkMode,
}: CalendarLegendItemProps) => {
    const textColor = useMemo(() => {
        const darkTextColor = hasDarkMode ? 'grayscale_400' : 'grayscale_900'
        const lightTextColor = hasDarkMode ? 'grayscale_500' : 'grayscale_700'

        return isDescriptionDark ? darkTextColor : lightTextColor
    }, [hasDarkMode, isDescriptionDark])

    return (
        <Box
            direction="row"
            gap={8}
            align={['flex-start', 'center']}
            isFullWidth
        >
            <CalendarLegendBadge
                badge={badge}
                badgeColor={badgeColor}
                badgeIcon={badgeIcon}
                hasDarkMode={hasDarkMode}
            />
            <CalendarLegendText variant="bodyExtraSmall" color={textColor}>
                {description}
            </CalendarLegendText>
        </Box>
    )
}

export default CalendarLegendItem
